import { downloadFile } from '@intelligence/utils/commonUtils';

export interface ICsvColumn {
  header: string;
  key: string;
}

/** Quote cells that contain comma, quote, or newline (same idea as Live Titles CSV). */
const escapeCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }
  const text = String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

/**
 * Flat-table CSV export — same logic as Live Titles `exportToCSV`
 * (headers from columns, rows from data keys).
 */
export const exportTableToCsv = ({
  fileName,
  columns,
  data,
}: {
  fileName: string;
  columns: ICsvColumn[];
  data: Array<Record<string, unknown>>;
}): void => {
  const headers = columns?.map((item) => item.header) || [];
  const keys = columns?.map((item) => item.key) || [];

  const rows: unknown[][] = [
    headers,
    ...(data || []).map((item) => keys.map((key) => item[key])),
  ];
  exportCsvRows({ fileName, rows });
};

/** Write arbitrary CSV rows (used when preamble notes/years must match Excel layout). */
export const exportCsvRows = ({
  fileName,
  rows,
}: {
  fileName: string;
  rows: unknown[][];
}): void => {
  const csvContent = `${rows.map((row) => row.map(escapeCsvCell).join(',')).join('\n')}\n`;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  downloadFile({ url, fileName: `${fileName}.csv` });
};
